import React from 'react'
import DropDownList from './../DropDownList'
import Search from './../Search'
import { useGeoState } from '../GeoProvider'
import styles from './MapOptions.module.scss'
import dayjs from 'dayjs'
const MapOptionsAllergies = ({regionDisplayOptions,diseaseDisplayOptions,entity, activeZip3,searchPlaceholder='Search State or Zip 3',geo_type}) => {  
  const {
    regionSelected,
    setRegionSelected,
    diseaseSelected, 
    setDiseaseSelected,
  } = useGeoState()
  const [searchCriteria, setSearchCriteria] = React.useState([])

  return (
    <div className={styles.base}>
      <div  className={styles.pageDiseaseList}> 
          <DropDownList
          id="diseases"
          name="diseases"
          onChange={(e) => {
            window.localStorage.setItem('disease',e.target.value)
            setDiseaseSelected(e.target.value)            
          }}
          className={styles.dropDowns}
          defaultValue={diseaseSelected}
        >
          {diseaseDisplayOptions.map((diseases, diseasesIndex) => {
            return (
              <DropDownList.Item
                value={diseases.value}
                key={diseases.value}
                selected={diseaseSelected.toString() === diseases.value}
              >
                {diseases.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
        </div>
      {geo_type==='nat'&&<div  className={styles.pageRegionList}> 
          <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            setRegionSelected(e.target.value)            
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
        </div>}
      <div className={styles.pageHeaderSearch}>
         
         
            { activeZip3 !==undefined && entity ==='allergies' && (
              <Search
                criteria={searchCriteria}
                onChange={setSearchCriteria}
                entity={entity}
                activeMetros={null}
                placeholder={searchPlaceholder}
                activeZip3={activeZip3}
                showMSAs={false}
              />
            )}
        </div>
    </div>
  )
}

export default MapOptionsAllergies
